import { DateTime } from "luxon";

import { DatasetId } from "@intelligems/ig-types";
import { DashboardPageName } from "@src/api/types/dashboards";
import { IExperienceDashboardFilters } from "@src/store/types/dashboardFilters";

export type ISitewideDashboardFilters = Pick<
  IExperienceDashboardFilters,
  | "startTime"
  | "endTime"
  | "channels"
  | "countryCodes"
  | "deviceType"
  | "visitorType"
  | "maxZScore"
  | "landingPage"
> & {
  pageName: DashboardPageName;
  isZScoreEnabled: boolean;
  interval: string;
  datasetId: DatasetId;
  ordersMatchedToSession: SiteWideOrdersMatchedToSessionType;
};

export type SiteWideOrdersMatchedToSessionType =
  | "allOrders"
  | "ordersMatchedToSession"
  | "all";

export const initialSitewideDashboardFiltersState: ISitewideDashboardFilters = {
  startTime: DateTime.now().minus({ days: 42 }).startOf("day").toMillis(),
  endTime: DateTime.now().toMillis(),
  countryCodes: [],
  deviceType: "any",
  visitorType: "any",
  channels: [],
  landingPage: {
    landingPageUrlPath: null,
    landingPageUrlPathFilterType: null,
  },
  maxZScore: null,
  pageName: "profit",
  isZScoreEnabled: true,
  interval: "1 MONTH",
  datasetId: "profit",
  ordersMatchedToSession: "allOrders",
};
